<template>
    <FormaPagamentoManage
        :idFrom="$route.params.id != undefined ? +$route.params.id : 0"
        @saved="redirectToList()"
        @voltar="$router.push({ name: 'des-forma-pagamento-list' })"
    />
</template>

<script>
import FormaPagamentoManage from '@/components/despesas/forma-pagamento/FormaPagamentoManage.vue';

export default {
    name: 'DesFormaPagamentoManageRoute',

    components: {
        FormaPagamentoManage,
    },
    methods: {
        redirectToList() {
            setTimeout(() => this.$router.push({ name: 'des-forma-pagamento-list' }), 1000);
        },
    },
};
</script>
